import React from 'react';
import ReactDOM from 'react-dom';
import CalendarApp from './CalendarApp';
import './style.css';

ReactDOM.render(<CalendarApp />, document.getElementById('root'));
